import React from "react";
import bg from "assets/bg.png";
import logo from "assets/logo.png";

function Home(props) {
  return (
    <div className="container">
      <div className="columns logoWrapper">
        <div className="column">
          <img src={logo} className="hlogo" />
        </div>
      </div>
      <div className="columns t1">
        <div className="column">
          <h1>Hadi bu yarışmayı kazan!</h1>
          <p>
            Sadece kazananlara özel büyük ödüllü <br/>Hadi bilgi yarışmasına katılmaya
            hak kazan!
          </p>
          {props.competitionStatus ? (<button className="button start" onClick={props.startClick}>Yarışmaya Başla</button>) : null}
        </div>
      </div>
    </div>
  );
}

export default Home;
